export const TextInform = {
    login: 'Как ещё можно войти',
    loginCard: 'Вход по\u00A0номеру карты',
    loginCardAccount: 'Вход по\u00A0номеру карты или\u00A0счёта',
    otherLogin: 'Другие способы входа',
    noOneLogin: 'Если ни\u00A0один способ не\u00A0подходит',
    cantLogin: 'Не получается войти?',
    howYouCanLogin: 'Как ещё можно войти',
};
